// extracted by mini-css-extract-plugin
module.exports = {"bybrow":"styles_bybrow__BcklB","authorName":"styles_authorName___jyiV","prefix":"styles_prefix__IqrhE"};